import useClientRender from '../../util/use-client-render'
import { getDistanceInWords } from './distance-in-words'

const Date = ({ time, className = '' }: { time: string; className?: string }) => {
    const canRender = useClientRender()
    return (
        <div className={className} suppressHydrationWarning>
            {canRender ? getDistanceInWords(time) : ''}
        </div>
    )
}
export default Date
